import React from "react";

const LocationGreyIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_190_1742"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_190_1742)">
        <path
          d="M10.0007 16.1248C11.6951 14.5693 12.952 13.1561 13.7715 11.8853C14.5909 10.6144 15.0007 9.48595 15.0007 8.49984C15.0007 6.98595 14.518 5.74637 13.5527 4.78109C12.5875 3.81581 11.4034 3.33317 10.0007 3.33317C8.59787 3.33317 7.41385 3.81581 6.44857 4.78109C5.48329 5.74637 5.00065 6.98595 5.00065 8.49984C5.00065 9.48595 5.41037 10.6144 6.22982 11.8853C7.04926 13.1561 8.30621 14.5693 10.0007 16.1248ZM10.0007 17.7707C9.80621 17.7707 9.61176 17.736 9.41732 17.6665C9.22287 17.5971 9.04926 17.4929 8.89648 17.354C7.99371 16.5207 7.1951 15.7082 6.50065 14.9165C5.80621 14.1248 5.22635 13.3575 4.76107 12.6144C4.29579 11.8714 3.94162 11.1561 3.69857 10.4686C3.45551 9.78109 3.33398 9.12484 3.33398 8.49984C3.33398 6.4165 4.00412 4.75678 5.3444 3.52067C6.68468 2.28456 8.23676 1.6665 10.0007 1.6665C11.7645 1.6665 13.3166 2.28456 14.6569 3.52067C15.9972 4.75678 16.6673 6.4165 16.6673 8.49984C16.6673 9.12484 16.5458 9.78109 16.3027 10.4686C16.0597 11.1561 15.7055 11.8714 15.2402 12.6144C14.775 13.3575 14.1951 14.1248 13.5007 14.9165C12.8062 15.7082 12.0076 16.5207 11.1048 17.354C10.952 17.4929 10.7784 17.5971 10.584 17.6665C10.3895 17.736 10.1951 17.7707 10.0007 17.7707ZM10.0007 9.99984C10.459 9.99984 10.8513 9.83664 11.1777 9.51025C11.5041 9.18387 11.6673 8.7915 11.6673 8.33317C11.6673 7.87484 11.5041 7.48248 11.1777 7.15609C10.8513 6.8297 10.459 6.6665 10.0007 6.6665C9.54232 6.6665 9.14996 6.8297 8.82357 7.15609C8.49718 7.48248 8.33398 7.87484 8.33398 8.33317C8.33398 8.7915 8.49718 9.18387 8.82357 9.51025C9.14996 9.83664 9.54232 9.99984 10.0007 9.99984Z"
          fill="#2B2B2B"
        />
      </g>
    </svg>
  );
};

export default LocationGreyIcon;
